export default __webpack_public_path__ + "static/media/grace_dugan.2d5c038b.jpg";